import React, { Component } from 'react'
import { Table, Divider, Form, message, Input, Modal, Col, DatePicker, Button, Row } from 'antd'
import './style.less'
import { getWithdrawInfo, getWithdraw, putWithdraw } from '../../../api/api'
class withdrawal extends Component {
	state = {
		loading: false,
		visible: false,
		fileList: [],

		isLoading: true,

		params: {
			pageNum: 0,
			pageSize: 10,
		},

		pageData: {
			total: 0,
			current: 1,
		},
		list: [],
		total: 0,
		merchantCount: 0,
		userCount: 0,
		fail: 0,
		pend: 0,
		success: 0,
	}

	componentDidMount () {
		const { params } = this.state
		getWithdrawInfo().then(res => {
			this.setState({
				total: res.data.merchantCount + res.data.userCount,
				merchantCount: res.data.merchantCount,
				userCount: res.data.userCount,
				fail: res.data.with.fail,
				pend: res.data.with.pend,
				success: res.data.with.success,
			})
		})
		this.loadList(params)
	}

	loadList (params) {
		const hide = message.loading('加载中...', 0)
		this.setState({ isLoading: true })
		getWithdraw(params)
			.then(res => {
				this.setState({
					list: res.data.content,
					isLoading: false,
					pageData: {
						current: res.data.pageable.pageNumber + 1,
						total: res.data.totalElements,
						pageSize: res.data.pageable.pageSize,
					},
				})
				hide()
			})
			.catch(err => {
				this.setState({
					list: [],
					isLoading: false,
					pageData: {
						current: 0,
						total: 0,
						pageSize: 0,
					},
				})
			})
	}


	showModal = (e) => {
		this.setState({
			visible: true,
			visibleData: e
		})
	}

	handleOk = () => {
		const { getFieldsValue } = this.props.form
		let param = getFieldsValue()
		if (!param.voucher) {
			return false
		}
		param['status'] = 1
		this.setState({ loading: true })
		putWithdraw(this.state.visibleData.type, this.state.visibleData.id, param).then(res => {
			this.setState({ loading: false, visible: false })
		})
			.catch(e => {
				this.setState({ loading: false, visible: false })
			})
	}

	handleCancel = () => {
		this.setState({ visible: false })
	}

	// 分页
	onPageChange = (e) => {
		if (this.state.isLoading) {
			return false
		}
		const { params } = this.state
		params.pageNum = e.current - 1
		this.loadList(params)
	}

	render () {
		const columns = [
			{
				title: '手机号',
				dataIndex: 'mobile',
				key: 'mobile',
			},
			{
				title: '类型',
				render: e => {
					switch (e.type) {
						case 1:
							return '用户'
						case 2:
							return '商户'
					}
				},
				key: 'type',
			},
			{
				title: '申请日期',
				dataIndex: 'createAt',
				key: 'createAt',
			},
			{
				title: '提现金额',
				render: e => {
					return (e.amount / 100).toFixed(2)
				},
				key: 'amount',
			},

			{
				title: '状态',
				render: e => {
					switch (e.status) {
						case 0:
							return '待处理'
						case 1:
							return '已提现'
						case 2:
							return '已拒绝'

					}
				},
				key: 'status',
			},
			{
				title: '汇款时间',
				render: e => {
					switch (e.transactionAt) {
						case null:
							return '-'
						default:
							return e.transactionAt

					}
				},
				key: 'transactionAt',
			},
			{
				title: '操作员',
				render: e => {
					switch (e.operator) {
						case null:
							return '-'
						default:
							return e.operator

					}
				},
				key: 'operator',
			},


			{
				title: '操作',
				key: 'action',
				render: (text, record) => (
					<span>
						{/* <a href="javascript:;">查看流水 </a> */}
						<Divider type="vertical" />
						<a href='javascript:' onClick={() => { this.showModal(text) } } >操作</a>
					</span>
				),
			},
		]
		const { visible, loading } = this.state
		const { getFieldDecorator } = this.props.form
		return (
			<div className='withdrawal-page'>
				<div className='board'>
					<Row>
						<Button onClick={() => {
							this.setState({
								params: {
									pageNum: 0,
									pageSize: 10,
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>全部({this.state.total})</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									type: 2
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>商家({this.state.merchantCount})</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									type: 1
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>用户({this.state.userCount})</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									status: 0
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>申请中({this.state.pend})</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									status: 1
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>已汇款({this.state.success})</Button>
						<Button onClick={() => {
							this.setState({

								params: {
									pageNum: 0,
									pageSize: 10,
									status: 2
								}
							}, () => {
								this.loadList(this.state.params)
							})
						}}
						>失败({this.state.fail})</Button>
					</Row>
					<Row className='search-board'>
						<Col lg={{ span: 6 }} style={{ width: 300 }} >
							<span >手机号搜索：</span>
							<Input 
								style={{ width: 180 }} 
								value={this.state.mobile} 
								onChange={(event) => {
									this.setState({ mobile: event.target.value })
								}} 
								placeholder="手机号" 
							/>
						</Col>
						<Col lg={{ span: 6 }} style={{ width: 320 }} >
							<span >提交时间：</span>
							<DatePicker style={{ width: 220 }} onChange={(e) => {
									this.setState({
										searchTime: e
									})
								}} 
							/>
						</Col>
						<Col lg={{ span: 2 }} >
							<Button type='primary' onClick={() => {
								let param = {
									pageNum: 0,
									pageSize: 10,
								}
								if (this.state.searchTime) {
									param['selectDate'] = this.state.searchTime.format('YYYY-MM-DD')
								}
								if (this.state.mobile) {
									param['mobile'] = this.state.mobile
								}
								this.setState({
									params: param
								}, this.loadList(this.state.params))
							}}
							>搜索</Button>
						</Col>
						<Col lg={{ span: 3 }} >
							<Button type="primary" icon="download">导出</Button>
						</Col>

					</Row>
				</div>
				<div className='tablecontain'>

					<Table
						bordered
						columns={columns}
						dataSource={this.state.list}
						rowKey="id"
						pagination={{
							current: this.state.pageData.current,
							total: this.state.pageData.total,
							pageSize: this.state.pageData.pageSize,
						}}
						onChange={this.onPageChange}
					/>
				</div>
				<Modal
					visible={visible}
					title="汇款"
					onOk={this.handleOk}
					onCancel={this.handleCancel}
					footer={[
						<Button key="back" onClick={this.handleCancel}>取消</Button>,
						<Button key="submit" type="primary" loading={loading} onClick={this.handleOk}>确定</Button>,
					]}
				>
					<Form className="modal-form">
						{
							!this.state.visible ? null : <Form.Item label="汇款金额" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>

								<Input
									value={(this.state.visibleData.amount / 100).toFixed(2)}
									disabled
									placeholder="请输入汇款金额"
								/>
							</Form.Item>
						}

						<Form.Item label="汇款凭证" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
							{getFieldDecorator('voucher', {
								rules: [{ required: true, message: '请输入汇款凭证' }],
							})(
								<Input
									autoComplete="off"
									placeholder="请输入汇款凭证"
								/>,
							)}
						</Form.Item>
						<Form.Item label="备注" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
							{getFieldDecorator('remarks', {
								rules: [{ required: false, message: '请输入备注' }],
							})(
								<Input
									autoComplete="off"
									placeholder="请输入备注"
								/>,
							)}
						</Form.Item>
					</Form>
				</Modal>
			</div>
		)
	}
}

export default Form.create({ name: 'post_data' })(withdrawal)